import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-passinfo',
  templateUrl: './passinfo.component.html',
  styleUrls: ['./passinfo.component.css']
})
export class PassinfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
